import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ProfileService {

    static getProfile(item) {

        let api = `${API_BASE_URL}${API_PATHS.getProfile}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getPrivacy(item) {

        let api = `${API_BASE_URL}${API_PATHS.getPrivacy}`;

        return axiosInstance.get(api, item);
    }

    static getSubCaste(item) {
        const api = `${API_BASE_URL}${API_PATHS.getSubCaste}`;

        return axiosInstance.get(api, {
            params: item,
        });
    }

    static getRecentActivity(item) {

        let api = `${API_BASE_URL}${API_PATHS.getRecentActivity}`;

        return axiosInstance.get(api, item);
    }


    static editProfile(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updateProfile}`;
        return axiosInstance
            .put(api, data)

    }
    static deletePhoto(payload) {
        const api = `${API_BASE_URL}${API_PATHS.deletePhoto}`;

        return axiosInstance.delete(api, {
            data: payload,
        });
    }

    static editPrivacy(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updatePrivacy}`;
        return axiosInstance
            .put(api, data)

    }

    static editFamilyDetails(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updateFamilyDetails}`;
        return axiosInstance
            .put(api, data)

    }


    static editProfessionalDetails(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updateProfessionalDetails}`;
        return axiosInstance
            .put(api, data)

    }


    static deleteProfile(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteProfile}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default ProfileService;
